import { render, staticRenderFns } from "./Capitulation.vue?vue&type=template&id=2220227e"
import script from "./Capitulation.vue?vue&type=script&lang=js"
export * from "./Capitulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports